import api from "./api";

export const getPackages = async () => {
  const response = await api.get("/Stripe/GetPackages");
  return response.data;
};

export const checkoutSession = async (payload: {[key:string]: string})=>{
    const response = await api.post("/Stripe/CheckoutSession", payload)
    return response.data
}

export const cancelSubscription = async (subscriptionId: string) => {
  const response = await api.post("/Stripe/CancelSubscription", {subscriptionId})
  return response.data
}